<template>

  <div class="question-view ">
    <FixedFontSizeSelector style="width: 50%;">
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>
      <div class="btn-list">
        <div :class="['single', its.check && 'check']" :data-id="its.id" v-for="(its, idx) in trueFlase" :key="idx" @click="checkSingle(idx, its.id)">
          <span :class="its.class"></span>
          {{ its.text }}
        </div>
      </div>
    </div>
    </FixedFontSizeSelector>
    <div class="quest-img" @click="$emit('urlToParent', form.img_url)">
      <img :src="form.img_url" :style="imgStyle" alt="">
    </div>

  </div>

</template>

<script>
import { isPC } from '@/utils/is-rules.js'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    return {
      mathjaxNum: 0,
      image: '',
      topic: '',
      trueFlase: [],

      imgStyle: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: null,
      // 记录答题次数
      limit: 0
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      this.limit = 0
      this.trueFlase.filter((its) => its.check = false)

      this.recordQuestion = null
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answer_id = form.answers[0].choice_id,
      blocks = document.querySelectorAll('.btn-list .single')
      
      if(recordQuestion == null) {
        return ;
      }
      this.limit = 1
      // this.trueFlase.filter((its) => its.id == recordQuestion ? its.check = true : its.check = false)
      console.log(recordQuestion)
      console.log(this.trueFlase)

      this.$nextTick(() => {
        for(let i = 0; i < this.trueFlase.length; i++) {
          let block = blocks[i],
          id = block.dataset.id
          block.setAttribute('class', 'single')
          if(recordQuestion == id) {
            this.trueFlase[i].check = true
            // block.classList.add('check')
  
            if(this.mode == 'question') {
              continue ;
            }
            console.log(block)
            this.$nextTick(() => {
              if(id == answer_id) block.classList.add('determine-success-br')
              else block.classList.add('determine-error-br')
            })
          }
        }
      })
      console.log(form)
    },
    checkSingle(idx, choice_id) {
      this.trueFlase.filter((its, index) => index == idx ? its.check = true : its.check = false)
      this.$emit('permissions', true)
      this.limit = 1
      this.recordQuestion = Number(choice_id)
      this.answer_results.student_choices = [{choice_id: Number(choice_id), value: ''}]
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = null
      this.trueFlase = []
      
      this.trueFlase = this.form.choices.map(its => 
        ({id: its.id, text: its.value == '0' ? '正確' : '錯誤', 
          check: false, class: its.value == '0' ? 'true-icon' : 'false-icon'}))
      setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  created() {
    if(isPC()) {
      this.imgStyle = {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        margin: 'auto'
      }
    }
    this.initData()
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 100%;
  padding: 20px ;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    width: calc(55% - 10px);
    height: 100%;
    .title {
      font-size: 18px;
      color: #333;
    }
    .btn-list {
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .single {
        width: calc(50% - 10px);
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        font-weight: 700;
        font-size: 18px;
        color: #333;
        .true-icon {
          position: relative;
          width: 28px;
          height: 28px;
          
          &:after {
            position: absolute;
            top: -5px;
            bottom: 0;
            left: -20px;
            right: 0;
            margin: auto;
            content: '';
            width: 20px;
            height: 11px;
            border: 4px solid #f6a053;
            border-top: none;
            border-right: none;
            border-radius: 2px;
            transform: rotateZ(-45deg);
          }
        }

        .false-icon {
          position: relative;
          width: 28px;
          height: 28px;
          
          &:after ,&:before {
            content: '';
            position: absolute;
            top: 0;
            left: -20px;
            right: 0;
            bottom: 0;
            margin: auto;
            background-color: #f6a053;
            width: 20px;
            height: 4px;
            transform-origin: center center;
            transform: rotateZ(-45deg);
            border-radius: 20px;
          }

          &:before {
            transform: rotateZ(45deg);
          }
        }

        &:hover {
          opacity: .8;
        }
      }
      .check {
        background-color: #f8ae64;
        border-color: #d17224;
        .true-icon {
          &:after {
            border-color: #d17224;
          }
        } 
        .false-icon {
          &:after, &:before {
            background-color: #d17224;
          }
        }
      }
    }
  }
  .quest-img {
  margin-left: 10px;
    max-width: 40%;
    flex: 1;
    max-height: 500px;
    aspect-ratio: 833/500;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    img {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>